import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveReviewV2Request } from './save-review-v2-request';
import type { ISaveReviewV2Response } from './save-review-v2-response';
import { saveReviewV2ResponseSchema } from './save-review-v2-response';

export async function saveReviewV2Api(
  body: ISaveReviewV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveReviewV2Response>> {
  return postRequest<ISaveReviewV2Response>({
    path: '/reviews/v2',
    body,
    schema: saveReviewV2ResponseSchema,
    options,
  });
}
